import Grid from '@mui/material/Grid';
import { Lesson } from '@/models/lesson';
import { LessonCard, LessonCardActionProp } from './LessonCard';
import { useMedia } from '@/hooks/useMedia/useMedia';
import { Skeleton } from '@mui/material';
import { SLIDE_PREVIEW_SIZE } from '@/constant';
import { useInView } from 'react-intersection-observer';

function LessonCardSkeleton() {
    return (
        <div data-testid='lesson-card-skeleton' style={{ border: '1px solid transparent' }}>
            <Skeleton height={SLIDE_PREVIEW_SIZE.height + 120} width={SLIDE_PREVIEW_SIZE.width} variant='rounded' />
        </div>
    );
}

type LessonsGridProps = {
    isSelecting?: boolean;
    selectedLessons?: Lesson[];
    lessons?: Lesson[];
    onLoadMore?: () => void;
    loading?: { size: number };
} & LessonCardActionProp;

export const LessonsGrid = ({ lessons, loading, onLoadMore, onPreviewClick, onActionClick, onSelected, isSelecting, selectedLessons }: LessonsGridProps) => {
    const { isMobile } = useMedia();
    const { ref } = useInView({
        threshold: 0,
        triggerOnce: true,
        onChange: (inView) => {
            if (inView) {
                onLoadMore?.();
            }
        },
    });

    return (
        <Grid container spacing={2} sx={{ justifyContent: isMobile ? 'space-evenly' : 'flex-start' }}>
            {lessons?.map((lesson, index) => (
                <Grid key={lesson.id} ref={index === lessons.length - 1 ? ref : undefined}>
                    <LessonCard
                        onSelected={onSelected}
                        lesson={lesson}
                        onPreviewClick={onPreviewClick}
                        onActionClick={onActionClick}
                        isSelecting={isSelecting}
                        isSelected={selectedLessons?.some((f) => f.id === lesson.id)}
                    />
                </Grid>
            ))}
            {loading &&
                loading.size > 0 &&
                Array.from(Array(loading.size)).map((_, index) => (
                    <Grid key={`lesson-card-skeleton-${index}`}>
                        <LessonCardSkeleton />
                    </Grid>
                ))}
        </Grid>
    );
};
